import { ColumnTable, Icon } from '@octano/global-ui';

export default function useColumns({
  onClickEdit,
  onClickRemove: onRemove,
}: {
  onClickEdit: (row: any) => void;
  onClickRemove: (row: any) => void;
}): ColumnTable[] {
  return [
    {
      columnName: 'code',
      headerText: 'Código',
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'name',
      headerText: 'Nombre',
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'address',
      headerText: 'Dirección',
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'Acciones',
      headerText: 'Acciones',
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ row }) => {
        return (
          <div className="d-flex justify-content-center">
            <button className="btn" onClick={() => onClickEdit(row)}>
              <Icon color="primary" name="edit" />
            </button>

            <button className="btn" onClick={() => onRemove(row)}>
              <Icon name="trash" color="primary" />
            </button>
          </div>
        );
      },
    },
  ];
}
